import http from '@/common/utils/http-common';
import ActSchedule, { QuickActScheduleRequest } from '@/types/ActSchedule.type';

class ActScheduleService {
  // 行動予定表
  getAll(params?: any) {
    return http.get('/act-schedules', params);
  }

  get(id: number) {
    return http.get(`/act-schedules/${id}`);
  }

  quick(data: QuickActScheduleRequest) {
    return http.put(`/act-schedules/quick`, data);
  }

  updatePlanRegistry(data: ActSchedule, id: number) {
    return http.put(`/act-schedules/${id}`, data);
  }
}

export default new ActScheduleService();
